<template>
    <div class="container-timeline inner-bar"
         @click="clickProgressBarTimeline"
         @mouseenter="mouseEnterAction"
         @mousedown="clickDownProgressBarTimeline"
         @mouseup="clickUpProgressBarTimeline"
         @mousemove="clickMoveProgressBarTimeline"
         @mouseleave="mouseLeaveAction"
         v-if="typeBar === 'showTimeline'">
        <div class="scrubber hover-colorable">
            <div class="scrubber-cover">
                <div class="scrubber-hover-area" v-if="playerReady"></div>
            </div>
        </div>
        <div class="buffer-play"></div>
        <div class="buffer-load"></div>
        <div class="scrubber-line-bar"></div>
        <timeline-hotspot-point />
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import TimelineHotspotPoint from "@/playerVue3/components/controlbar/components/timeline-hotspot-point.vue";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS
const emit = defineEmits(['timeEvent']);

// REACTIVE VARIABLES
const isDragProgressBar = ref(false);
const videoDuration = ref(0);
const currentTimeVideoSeconds = ref(0);
const currentTimeVideoToShow = ref('');

// COMPUTED PROPERTIES
const playerReady = computed(() => {
    if (store.getPlayerIsReady) {
        store.getPlayer.on('time', () => {
            updateProgressBarVideoTimeLinePointer(store.getPlayer.getPosition());
            currentTimeVideoSeconds.value = store.getPlayer.getPosition();
            currentTimeVideoToShow.value = formatTime(currentTimeVideoSeconds.value.toFixed(0));
            emit('timeEvent', currentTimeVideoSeconds.value);
        });
        return true;
    }
    return false;
});

const typeBar = computed(() => {
    // 1 = Hide Timeline, 2 = Show Timeline
    let typeBar = 'hideTimeline';
    if (store.getVideoData.typePlayBar.typePlayBarId === 2) {
        typeBar = 'showTimeline';
    } else if (store.getVideoData.typePlayBar.typePlayBarId === 1 && store.getModeAdmin) {
        typeBar = 'showTimeline';
    }
    return typeBar;
});

// METHODS
const mouseEnterAction = (event) => {
    isDragProgressBar.value = false;
};

const mouseLeaveAction = (event) => {
    if (isDragProgressBar.value && event.toElement != undefined && event.toElement.id === 'videoPlayerContainer') {
        const positionXOnPage = event.pageX;
        updateProgressBarPointPosition(positionXOnPage, true);
        isDragProgressBar.value = false;
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
    }
};

const clickProgressBarTimeline = () => {
    store.getPlayer.pause();
    const positionXOnPage = event.pageX;
    updateProgressBarPointPosition(positionXOnPage);
};

const clickDownProgressBarTimeline = (event) => {
    store.getPlayer.pause();
    isDragProgressBar.value = true;
};

const clickUpProgressBarTimeline = (event) => {
    isDragProgressBar.value = false;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
};

const clickMoveProgressBarTimeline = (event) => {
    if (isDragProgressBar.value) {
        const positionXOnPage = event.pageX;
        updateProgressBarPointPosition(positionXOnPage);
    }
};

const formatTime = (sec) => {
    return (sec - (sec %= 60)) / 60 + (9 < sec ? ':' : ':0') + sec;
};

const updateProgressBarPointPosition = (positionXOnPage, movePointerVideo = false) => {
    const progressBar = $('.inner-bar');
    const mousePosition = positionXOnPage - progressBar.offset().left;
    let timePercentageByMousePosition = 100 * mousePosition / progressBar.width();

    //Check within range
    if (timePercentageByMousePosition > 100) {
        timePercentageByMousePosition = 100;
    }
    if (timePercentageByMousePosition < 0) {
        timePercentageByMousePosition = 0;
    }

    //Update progress bar and video current time
    $('.scrubber').css('left', timePercentageByMousePosition + '%');
    if (!isDragProgressBar.value) {
        setTimeout(() => {
            store.getPlayer.seek(videoDuration.value * timePercentageByMousePosition / 100);
            //store.getPlayer.play();
        }, 5);
        setTimeout(() => {
            store.getPlayer.play();
        }, 200);
    } else if (isDragProgressBar.value && movePointerVideo) {
        store.getPlayer.seek(videoDuration.value * timePercentageByMousePosition / 100);
    }
};

const updateProgressBarVideoTimeLinePointer = (currentTime) => {
    let executionPercentage = 100 * currentTime / videoDuration.value;
    if (executionPercentage > 99.8) {
        executionPercentage = 99.8;
    }
    if (executionPercentage < 0) {
        executionPercentage = 0;
    }
    $('.scrubber').css('left', executionPercentage + '%');
    $('.buffer-play').css('width', executionPercentage + '%');
};

// LIFECYCLE HOOKS
onMounted(() => {
    videoDuration.value = parseFloat(store.getVideoData.duration);
});
</script>
